import { render, staticRenderFns } from "./bannerplayer.vue?vue&type=template&id=db95cc16&"
import script from "./bannerplayer.vue?vue&type=script&lang=js&"
export * from "./bannerplayer.vue?vue&type=script&lang=js&"
import style0 from "./bannerplayer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports